@if(isMciUpdating()) {
    <div (click)="openMciPanel()" class="mt-2">
        <iq-mc-info-badge [params]="infoBadgeQueryParams()"></iq-mc-info-badge>
    </div>

} @else {
    <div
        class="w-full max-w-[1140px]"
        [attr.data-testid]="id()"
        [attr.data-styletarget]="id()"
    >
        <div class="flex align-items-center gap-2">
            @if(!!dataInfoMci()) {
                <h3
                    [attr.data-testid]="id() + '-data-info'"
                    [attr.data-styletarget]="id() + '-data-info'"
                    [attr.data-uitype]="'title-h3'"
                    [datiqTemplateMd]="dataInfoMci()"
                    class="font-body-2 mb-4"
                >
                </h3>
                <span 
                    class="material-symbols-outlined mb-4 self-center !text-[18px]" 
                    (click)="openMciPanel()"
                >help</span>
            } @else {
                <div [attr.data-testid]="id() + '-data-info-empty'"
                [attr.data-styletarget]="id() + '-data-info-empty'">
                    <h3 [attr.data-uitype]="'title-h3'" class="font-body-2 mb-4" > </h3>
                </div>
            }
        </div>


        @if(!noDataMci()) {
        <div
            class="h-2 flex divide-x divide-white mb-4"
            [attr.data-testid]="id() + '-gauge'"
            [attr.data-styletarget]="id() + '-gauge'"
            [attr.data-uitype]="'viz-bar'"
        >
            @for (step of steps(); track i; let i = $index; let last = $last){
            <div
                class="relative"
                [attr.data-testid]="id() + '-gauge-step-' + i"
                [attr.data-styletarget]="id() + '-gauge-step-' + i"
                [attr.data-uitype]="'viz-bar-step'"
                [style.width.%]="(1 / steps().length) * 100 | number: '1.0-0'"
                [style.margin-right.px]="last ? 0 : 4"
                [class.bg-dat-grey-300]="!loadedMci() && !fetchedMci()"
                [style.background]="!geographySelected() || (loadedMci() && fetchedMci())? step.color: ''"
                [class.animate-pulse]="geographySelected() && !fetchedMci() && !loadedMci()"
                [ngStyle]="{
                    'animation-delay':
                        fetchedMci() && !loadedMci() ? i * 200 : 'none'
                }"
            >
                <label
                    [attr.data-testid]="id() + '-label-loads'"
                    [attr.data-styletarget]="id() + '-label-loads'"
                    [attr.data-uitype]="'label'"
                    class="font-caption-micro text-dat-grey-500 w-1/2 inline-block text-left mt-[15px]"
                >
                    {{ (step.low > 0 ? '+' : '') + step.low }}
                </label>
                @if(last) {
                <label
                    [attr.data-testid]="id() + '-label-trucks'"
                    [attr.data-styletarget]="id() + '-label-trucks'"
                    [attr.data-uitype]="'label'"
                    class="font-caption-micro text-dat-grey-500 w-1/2 inline-block text-right mt-[15px]"
                >
                    {{ (step.high > 0 ? '+' : '') + step.high }}
                </label>
                } @if(gaugeMarkerPositionIndex() === step?.index && loadedMci()){
                <div
                    [style.background]="step?.color"
                    [style.top.px]="-4"
                    [style.left]="'calc(' + gaugeMarkerPosition() + '% - 12px)'"
                    [style.border-radius.px]="99999"
                    class="absolute h-4 w-4 z-9"
                ></div>
                <mat-icon
                    [style.top.px]="-8"
                    [style.left]="'calc(' + gaugeMarkerPosition() + '% - 16px)'"
                    [style.border-radius.px]="99999"
                    class="absolute font-bold material-symbols-outlined z-10"
                >
                    circle
                </mat-icon>
                }
            </div>

            }
        </div>
        }
    </div>
}
